<template>
  <template v-for="toast in toasts" :key="toast.id">
    <v-snackbar
      :model-value="true"
      :color="toast.type"
      location="top right"
      :timeout="4000"
      rounded="lg"
      @update:model-value="remove(toast.id)"
    >
      <div class="app-toast__message">{{ toast.message }}</div>
      <template #actions>
        <v-btn icon size="small" variant="text" @click="remove(toast.id)">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
  </template>
</template>

<script setup lang="ts">
const toasts = useToastState()
const { remove } = useToast()
</script>

<style scoped>
.app-toast__message {
  white-space: pre-line;
}
</style>
